module.exports = __webpack_public_path__ + "static/media/EnvPromo-Shot24.a7f00924.jpg";